export var EXTENSION_PREFIXES = ['chrome-extension://', 'moz-extension://'];
export function containsExtensionUrl(str) {
  return EXTENSION_PREFIXES.some(function (prefix) {
    return str.includes(prefix);
  });
}
/**
 * Utility function to detect if the SDK is being initialized in an unsupported browser extension environment.
 *
 * @param windowLocation - The current window location to check
 * @param stack - The error stack to check for extension URLs
 * @returns true if running in an unsupported browser extension environment
 */
export function isUnsupportedExtensionEnvironment(windowLocation) {
  var stack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  // If the page itself is an extension page.
  if (containsExtensionUrl(windowLocation)) {
    return false;
  }
  // Since we generate the error on the init, we check the 2nd frame line.
  var frameLines = stack.split('\n').filter(function (line) {
    var trimmedLine = line.trim();
    return trimmedLine.length && /^at\s+|@/.test(trimmedLine);
  });
  var target = frameLines[1] || '';
  return containsExtensionUrl(target);
}